// extracted by mini-css-extract-plugin
module.exports = {"solution":"decision_qpc_list-module__solution--1GLJ_"};